/*! HOLO Pets — shared below-fold lazy video loader */
(function () {
  if (window.__HOLO_PETS_LAZY_VIDEO__) return;
  window.__HOLO_PETS_LAZY_VIDEO__ = true;

  function isVisible(el) {
    if (!el || !el.isConnected) return false;
    var node = el;
    while (node && node.nodeType === 1) {
      var style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      node = node.parentElement;
    }
    return true;
  }

  function collectVideos(root) {
    var scope = root || document;
    return Array.prototype.slice.call(scope.querySelectorAll('[data-holo-lazy-video]')).filter(isVisible);
  }

  function arm(video, reduce) {
    if (!video || video.dataset.holoLazyArmed === '1') {
      if (!reduce && video && video.paused) {
        video.muted = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
      return;
    }
    var source = video.querySelector('source[data-src]');
    if (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
      video.load();
    }
    video.dataset.holoLazyArmed = '1';
    if (reduce) return;
    video.muted = true;
    var play = video.play();
    if (play && typeof play.catch === 'function') play.catch(function () {});
  }

  function pause(video) {
    if (video && !video.paused) video.pause();
  }

  function boot() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var videos = collectVideos(document);
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { arm(v, reduce); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (!isVisible(video)) {
            pause(video);
            return;
          }
          if (entry.isIntersecting && entry.intersectionRatio >= 0.18) arm(video, reduce);
          else pause(video);
        });
      },
      { root: null, rootMargin: '140px 0px', threshold: [0, 0.18, 0.4] }
    );

    videos.forEach(function (video) { io.observe(video); });

    document.addEventListener('shopify:section:load', function () {
      collectVideos(document).forEach(function (video) {
        try { io.observe(video); } catch (e) {}
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
